import React, {Component} from 'react';
import {FaIcon} from "../../../FaIcon";
import { withTranslation } from 'react-i18next';

class LeadDetailMainInfo extends Component {
    render() {
        const { t } = this.props;
        return (
            <div className="lead-main-info">
                <p className="lead-info">
                    <FaIcon iconName="phone"/>{this.props.leadData.phoneNumber}
                </p>
                <p className="lead-info">
                    <FaIcon iconName="envelope"/>{this.props.leadData.email}
                </p>
                <p className="lead-info">
                    <a href={'//' + this.props.leadData.landingUrl} target='blank'>
                        <FaIcon iconName="link"/>{this.props.leadData.landingUrl}
                    </a>
                </p>
                {this.extraFields()}
                <p className="lead-info"><span>{t('lead_detail.message')}</span>{this.props.leadData.message}</p>
            </div>
        )
    }

    extraFields() {
        return Object.keys(this.props.leadData.extraFields).map(fieldName => {
            return <p className="lead-info"><span>{fieldName}:</span>{this.props.leadData.extraFields[fieldName]}</p>
        });
    }
}

export default withTranslation()(LeadDetailMainInfo);